import React from 'react';
import styled from 'styled-components';
import { PulseLoader } from '../Shared/pulse-loader';

interface SearchResultsLoadingIndicatorProps {
    isLoading: boolean;
}

const SearchResultsLoadingIndicator = (props: SearchResultsLoadingIndicatorProps) => {

    if (!props.isLoading) return <React.Fragment />

    return (
        <Container>
            <PulseLoader iconSize='2rem' />
        </Container>
    );
};

export default SearchResultsLoadingIndicator;

const Container = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;

